(function () {
  'use strict';
  if (window.mrzFitGuideInitialized) return;
  window.mrzFitGuideInitialized = true;
  var dialog = document.getElementById('MrzExitOffer');
  if (!dialog || typeof dialog.showModal !== 'function' || document.querySelectorAll('#MrzExitOffer').length !== 1) return;
  var VISIT = 'mrzFitVisitV1';
  var DISMISSED = 'mrzFitDismissedUntilV1';
  var SUBSCRIBED = 'mrzFitSubscribedV1';
  var DELAY = 600000;
  var VISIT_IDLE = 1800000;
  var SEVEN_DAYS = 604800000;
  var storageOK = true;
  var syncing = false;
  var lastTick = Date.now();
  var active = !document.hidden && document.hasFocus();

  function read(key) {
    try { return window.localStorage.getItem(key); }
    catch (e) { storageOK = false; return null; }
  }
  function write(key, value) {
    try {
      window.localStorage.setItem(key, value);
      if (window.localStorage.getItem(key) !== value) storageOK = false;
    } catch (e) { storageOK = false; }
    return storageOK;
  }
  function visit(now) {
    var raw = read(VISIT);
    if (raw) {
      try {
        var v = JSON.parse(raw);
        if (!Number.isFinite(v.lastActive) || !Number.isFinite(v.activeMs) || v.activeMs < 0 || typeof v.shown !== 'boolean') throw new Error('Invalid visit');
        if (now < v.lastActive) { storageOK = false; return v; }
        if (now - v.lastActive < VISIT_IDLE) return v;
      } catch (e) { storageOK = false; }
    }
    return { lastActive: now, activeMs: 0, shown: false };
  }
  function subscribed() {
    return dialog.getAttribute('data-mrz-subscribed') === 'true' || read(SUBSCRIBED) === '1';
  }
  function dismissed() {
    var value = read(DISMISSED);
    if (value && !Number.isFinite(Number(value))) { storageOK = false; return true; }
    return Number(value) > Date.now();
  }
  function blockedPage() {
    var p = (window.location.pathname || '/').toLowerCase().replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/, '');
    return /^\/(?:cart|checkout|checkouts|account|orders)(?:\/|$)/.test(p) || /^\/(?:tools|apps)\//.test(p) || p.indexOf('/pages/checkout-terms') === 0;
  }
  function visible(el) {
    if (!el.getClientRects().length) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
  }
  function busy() {
    var el = document.activeElement;
    if (el && (el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName))) return true;
    var overlays = document.querySelectorAll('.mrz-gate, dialog[open], [aria-modal="true"], .modal__content[open], cart-drawer.active, .menu-drawer-container details[open]');
    for (var i = 0; i < overlays.length; i++) if (overlays[i] !== dialog && visible(overlays[i])) return true;
    return false;
  }
  function markSubscribed() { write(SUBSCRIBED, '1'); }
  function dismiss() {
    if (!syncing) write(DISMISSED, String(Date.now() + SEVEN_DAYS));
  }
  dialog.addEventListener('close', dismiss);
  dialog.addEventListener('cancel', dismiss);
  dialog.addEventListener('click', function (event) {
    var closer = event.target.closest ? event.target.closest('[data-mrz-close]') : null;
    if (closer || event.target === dialog) {
      event.preventDefault();
      dismiss();
      dialog.close();
    }
  });
  if (dialog.getAttribute('data-mrz-subscribed') === 'true' || document.querySelector('[data-mrz-signup-success]')) markSubscribed();
  var initial = visit(Date.now());
  write(VISIT, JSON.stringify(initial));

  function tick() {
    var now = Date.now();
    var elapsed = Math.max(0, Math.min(2000, now - lastTick));
    lastTick = now;
    var wasActive = active;
    active = !document.hidden && document.hasFocus();
    if (!storageOK || subscribed() || dismissed()) return;
    var v = visit(now);
    if (wasActive && !blockedPage()) {
      v.activeMs = Math.min(DELAY, v.activeMs + elapsed);
      v.lastActive = now;
      if (!write(VISIT, JSON.stringify(v))) return;
      dialog.setAttribute('data-mrz-active-ms', String(v.activeMs));
    }
    if (!active || !wasActive || v.shown || v.activeMs < DELAY || blockedPage() || busy() || !storageOK) return;
    v.shown = true;
    if (!write(VISIT, JSON.stringify(v))) return;
    try { dialog.showModal(); } catch (e) { return; }
    var target = dialog.querySelector('[data-mrz-initial-focus]');
    if (target) target.focus();
  }
  window.setInterval(tick, 1000);
  document.addEventListener('visibilitychange', tick);
  window.addEventListener('focus', tick);
  window.addEventListener('blur', tick);
  window.addEventListener('pagehide', function () {
    tick();
    if (dialog.open) {
      dismiss();
      dialog.close();
    }
  });
  window.addEventListener('pageshow', function () {
    lastTick = Date.now();
    active = !document.hidden && document.hasFocus();
  });
  window.addEventListener('storage', function (event) {
    if (event.key !== DISMISSED && event.key !== SUBSCRIBED) return;
    if (dialog.open && (subscribed() || dismissed())) {
      syncing = true;
      dialog.close();
      window.setTimeout(function () { syncing = false; }, 0);
    }
  });
})();
